import { YearOptionType } from '@/types/pages/Profile/yearOptionType';

export const yearDefault: YearOptionType[] = [
  {
    name: '1年未満',
    value: 0,
  },
  {
    name: '1年~',
    value: 1,
  },
  {
    name: '3年~',
    value: 3,
  },
  {
    name: '5年~',
    value: 5,
  },
  {
    name: '10年~',
    value: 10,
  },
];
